export default __webpack_public_path__ + "static/media/Gold-Render-Square-removebg-md.c5b93eff.png";